import React from "react";
import { connect } from "react-redux";

class Event extends React.Component {
  render() {
    if (this.props.event || this.props.renderAnyway) {
      return this.props.children(this.props.event);
    } else {
      return null;
    }
  }
}

export default connect((state, ownProps) => {
  return {
    event: (state.events.live[ ownProps.eventId ] || state.events.prematch[ ownProps.eventId ])
  };
}, {})(Event);


// WEBPACK FOOTER //
// ./app/components/EsportsGame/Event/Event.jsx